import { withStyles } from '@material-ui/styles';
import { withTranslation } from 'react-i18next';
import { compose, pure } from 'recompose';
export const withBaseProps = (hocConfig = {}) => (Component) => {
    const { styles, withTheme = true, translations, isPure = true } = hocConfig;
    const hocs = [styles && withStyles(styles, { withTheme }), withTranslation(translations), isPure && pure].filter(Boolean);
    return compose(...hocs)(Component);
};
export default withBaseProps;
//# sourceMappingURL=withBaseProps.js.map